/**
 *  @class
 *  @function ImageTextOverlay (no SplitText)
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();
      this.tl = false;
    }

    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }

    disconnectedCallback() {
      if (this.tl && typeof gsap !== 'undefined') {
        this.tl.kill();
      }
    }

    prepareAnimations() {
      const section = this;
      let property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      // Set up scroll animation timeline
      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      // Simple fade-in animations (no SplitText)
      if (section.querySelector('.subheading')) {
        section.tl.fromTo(
          section.querySelector('.subheading'),
          { opacity: 0 },
          { duration: 0.75, opacity: 1 },
          0
        );
      }

      if (section.querySelector('h3, h1, h2')) {
        section.tl.fromTo(
          section.querySelectorAll('h3, h1, h2'),
          { opacity: 0, y: 20 },
          { duration: 0.8, opacity: 1, y: 0, stagger: 0.1 },
          0.2
        );
      }

      if (section.querySelector('.rte p')) {
        section.tl.fromTo(
          section.querySelectorAll('.rte p'),
          { opacity: 0, y: 20 },
          { duration: 0.8, opacity: 1, y: 0, stagger: 0.05 },
          0.4
        );
      }

      if (section.querySelectorAll('.button')) {
        section.querySelectorAll('.button').forEach((item, i) => {
          section.tl.fromTo(
            item,
            { autoAlpha: 0, y: 10 },
            { duration: 0.5, autoAlpha: 1, y: 0 },
            0.6 + i * 0.1
          );
        });
      }

      // Parallax effect remains
      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(
          section.querySelectorAll('.thb-parallax-image'),
          { y: '-8%' },
          {
            y: '8%',
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              start: () => `top bottom`,
              end: () => `bottom top+=${property}`,
              onUpdate: () => {
                property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
              }
            }
          }
        );
      }
    }
  }

  customElements.define('image-with-text-overlay', ImageTextOverlay);
}
